module.exports = __webpack_public_path__ + "static/media/playlist-info-icon.c7126104.svg";